

export default class mapbsRealestateadress {
    constructor() {
        /**@type {number} */
        this.adressId = 0;
        /**@type {number} */
        this.egaid = 0;
        /**@type {string} */
        this.street = '';
        /**@type {string} */
        this.number = '';
        /**@type {number} */
        this.postalCode = 0;
        /**@type {string} */
        this.municipality = '';
        /**@type {string} */
        this.status = '';
        /**@type {boolean} */
        this.containedByRealEstate = false;

    }

    getRealestateAdressObject(jsonObj) {
        this.adressId = jsonObj['AdressID'];
        this.egaid = jsonObj['EGAID'];
        this.street = jsonObj['Street'];
        this.number = jsonObj['Number'];
        this.postalCode = jsonObj['PostalCode'];
        this.municipality = jsonObj['Municipality'];
        this.status = jsonObj['Status'];
        this.containedByRealEstate = jsonObj['ContainedByRealEstate'];
    }
}

